<template>
  <section class="service-location"
           :class="{'py-2' : !serviceLocation.bgImg }"
           :style="!this.isMobile && backgroundImg">
    <div class="content container"
         :class="{'py-4' : !serviceLocation.bgImg }">
      <h2>{{ serviceLocation.title }}</h2>
      <p v-html="serviceLocation.description"></p>
      <div
          class="section-part"
          v-if="serviceLocation.separateLocations"
          v-for="section in serviceLocation.sections"
          :key="section.id"
      >
        <div
          class="section-header"
          :class="[{ 'active': openedItem === section.id }]"
          @click="handleItemClick(section.id)"
        >
          <p class="h5">{{ section.title }}</p>
        </div>
        <ul
          class="section-list"
          :class="[{ 'active': openedItem === section.id }]"
          @click="handleItemClick(section.id)"
        >
          <li
              v-for="item in section.children"
              :key="item.id"
              :class="{'item-link': item.hasDetailPage}"
          >
            <a :href="item.link" v-if="item.hasDetailPage">{{ item.title }}</a>
            <span v-else>{{ item.title }}</span>
          </li>
        </ul>
      </div>
      <div class="section-part" v-else>
        <ul>
          <li
              v-for="item in serviceLocation.sections.flatMap(s => s.children)"
              :key="item.id"
              :class="{'item-link': item.hasDetailPage}"
          >
            <a :href="item.link" v-if="item.hasDetailPage">{{ item.title }}</a>
            <span v-else>{{ item.title }}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false,
      openedItem: null,
    }
  },
  props: {
    serviceLocation: {
      title: String,
      description: HTMLElement,
      bgImg: String,
      sections: Array,
      separateLocations: Boolean
    }
  },
  computed: {
    backgroundImg() {
      return `background-image: url("${this.serviceLocation.bgImg}");`;
    }
  },
  methods: {
    handleItemClick(id) {
      this.openedItem = this.openedItem === id ? null : id;
    }
  },
  created() {
    this.isMobile = window.visualViewport.width < 576;
    this.openedItem = null;
  }
}
</script>
